import React, { useState, useEffect } from "react";
import { fetchTestimonials } from "../utils/testimonialsApi";
import { motion } from "framer-motion";
import './Testimonials.css';

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetchTestimonials().then((data) => setTestimonials(data || []));
  }, []);

  return (
    <div className="container-fluid py-5 overflow-hidden">
      <div className="container p-0">
        <motion.div 
          className="text-center pb-2"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="section-title px-5">
            <span className="px-2">Testimonials</span>
          </p>
          <h1 className="mb-4">What Parents Say!</h1>
        </motion.div>
        <motion.div 
          className="testimonial-marquee-wrapper"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <div className="testimonial-marquee-inner">
            {/* Map twice to create the infinite looping effect */}
            {[...testimonials, ...testimonials].map((testimonial, idx) => (
              <div className="testimonial-slide-card" key={idx}>
                <i className="fa fa-quote-left testimonial-quote-icon"></i>
                <p className="quote-text">
                  "{testimonial.text}"
                </p>
                <div className="testimonial-author-wrapper">
                  <h5>{testimonial.name}</h5>
                  <small>{testimonial.role}</small>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
